// extracted by mini-css-extract-plugin
export var active = "_90-a";
export var activeIndicator = "_90-9";
export var disabled = "_90-b";
export var fullWidth = "_90-2";
export var lg = "_90-7";
export var md = "_90-6";
export var redoButtonTabGroup = "_90-0";
export var sm = "_90-5";
export var tabButton = "_90-4";
export var tabButtonsContainer = "_90-1";
export var themeDestructive = "_90-d";
export var themeNormal = "_90-c";
export var themeSuccess = "_90-e";
export var xl = "_90-8";
export var xs = "_90-3";